import { P } from 'ia-react-core';
import styled from 'styled-components';

export const StyledP = styled(P)`
  font-size: 12px;
  line-height: 14px;
  color: ${({ theme }) => theme.colors.gray14};
  margin-top: 20px;
  margin-bottom: 0px;
`;

export const StyledLinePrompt = styled(P)`
  margin-top: 26px;
  font-size: 12px;
  line-height: 1.17;
`;
